import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders } from '@fortawesome/free-solid-svg-icons';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import pictureInPictureIcon from '../../../assets/PictureInPicture.svg';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { setSettingsView } from '../../../features/videoPlayer/videoPlayer.slice';


const PlayerSettings = ({ videoRef }) => {

  const dispatch = useDispatch();
  
  const handlePictureInPicture = async () => {
    if (videoRef.current) {
      try {
        if (document.pictureInPictureElement) {
          await document.exitPictureInPicture();
        } else {
          await videoRef.current.requestPictureInPicture();
        }
      } catch (error) {
        console.error("Error with Picture-in-Picture:", error);
      }
    }
  };

  const handleChangeOfView = (view) => {
    dispatch(setSettingsView(view));
  };

  return (
    <div
        id='player-settings'
        style={{
        position: 'absolute',
        top: '60px',
        right: '30px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#1A1A1A',
        width: '300px',
        // height: '100px',
        borderRadius: '5px',
        padding: '20px',
        justifyContent: 'space-between',
        // alignItems: 'center',
        color: '#fff',
        zIndex: 3,
        // visibility: hovering && showSettings && settingsView === 'main' ? 'visible' : 'hidden'
        }}
    >
        <h5 className='m-0'>Settings</h5>
        <hr />
        <div className='d-flex flex-row gap-3' onClick={() => handleChangeOfView("playbackSpeed")} style={{cursor: 'pointer'}}>
          <FontAwesomeIcon icon={faGauge} style={{fontSize: '20px', paddingTop: '3px'}} />
          <p className='m-0 ps-1 pb-1'>Playback Speed</p>
          <FontAwesomeIcon icon={faChevronRight} style={{fontSize: '15px', paddingTop: '6px', marginLeft: 'auto'}} />
        </div>
        {/* <div className='d-flex flex-row gap-3' onClick={() => handleChangeOfView("quality")} style={{cursor: 'pointer'}}>
          <FontAwesomeIcon icon={faSliders} style={{fontSize: '20px', paddingTop: '3px'}}/>
          <p className='m-0 ps-1 pb-1'>Quality</p>
          <FontAwesomeIcon icon={faChevronRight} style={{fontSize: '15px', paddingTop: '6px', marginLeft: 'auto'}} />
        </div> */}
        <div className='d-flex flex-row gap-3' onClick={() => handlePictureInPicture()} style={{cursor: 'pointer'}}>
          {/* <FontAwesomeIcon icon={faRectanglePicture} /> */}
          <img src={pictureInPictureIcon} alt="Picture in Picture" style={{ width: '25px', height: '25px' }}/>
          <p className='m-0'>Picture in Picture</p>
          {/* <FontAwesomeIcon icon={faChevronRight} style={{fontSize: '15px', paddingTop: '6px', marginLeft: 'auto'}} /> */}
        </div>
    </div>
  )
}

export default PlayerSettings